import Vue from 'vue'

let modal = new Vue({
  data () {
    return {
      element: null,
      isModalVisible: false,
      methodToRun: null,
      modalBody: null,
      updatedData: ''
    }
  },

  created () {
    document.addEventListener('keyup', (event) => {
      let key = event.key || event.keyCode
      if (key === 'Escape' || key === 'Esc' || key === 27) {
        this.closeModal()
      }
    })
  },

  methods: {
    closeModal () {
      this.isModalVisible = false
      this.element = null
      this.modalBody = null
    },

    showModal (modalBody, element = null) {
      this.element = element
      this.modalBody = modalBody
      this.isModalVisible = true
    },

    updateData (methodToRun = null) {
      this.methodToRun = methodToRun
      this.updatedData = Date.now()
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$modal = modal
  }
}
